import { cn } from '@repo/tailwind-config/tailwind.functions'

interface NotificationLogoProps {
  isUnread: boolean
}

const NotificationLogo: React.FC<NotificationLogoProps> = ({ isUnread }) => {
  return (
    <div
      className={cn('rounded-full w-10 h-10 flex items-center justify-center transition-colors', {
        'bg-primary': isUnread,
        'bg-grey-light': !isUnread
      })}
    >
      <img src={!isUnread ? '/logo-dark.png' : '/logo.png'} alt="Logo" className="p-2" />
    </div>
  )
}

export default NotificationLogo
